import React from 'react';
import { Icon } from '@iconify-icon/react';

const problems = [
  {
    number: '01',
    icon: 'tabler:folders-off',
    title: 'Knowledge lives everywhere',
    body: "Policies in Drive, SOPs in Notion, tribal know-how in Slack threads, and the real answers in someone's head. When that person leaves, the knowledge walks out with them.",
  },
  {
    number: '02',
    icon: 'tabler:clock-question',
    title: 'Answers take forever',
    body: 'New hires ping three teammates before they find the right doc. Support escalates the same question weekly. Leaders spend hours hunting for "the latest version."',
  },
  {
    number: '03',
    icon: 'tabler:versions',
    title: 'Nobody trusts the version',
    body: 'Stale PDFs, conflicting wiki pages, and hallway advice create risk. Without citations, people guess — and guessing is expensive when the answer affects customers or compliance.',
  },
];

const TheKnowledgeProblem: React.FC = () => (
  <section aria-label="Why companies need a company brain" className="bg-white py-20 sm:py-24">
    <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
      <div className="max-w-2xl">
        <span className="text-[11px] font-semibold uppercase tracking-[0.24em] text-[#b8862e]">
          The problem
        </span>
        <h2 className="mt-3 text-3xl font-extrabold tracking-tight text-gray-900 sm:text-4xl">
          Your company already has a brain.{' '}
          <span className="font-display font-medium italic text-[#004790]">
            It just isn&apos;t connected.
          </span>
        </h2>
        <p className="mt-4 text-lg leading-relaxed text-gray-500">
          Institutional knowledge is the most valuable asset most organizations never organize. Here
          is what that costs every day.
        </p>
      </div>

      <div className="mt-12 grid gap-8 md:grid-cols-3">
        {problems.map((item) => (
          <div
            key={item.number}
            className="group relative rounded-2xl border border-gray-100 bg-gray-50/50 p-7 transition-all duration-300 hover:-translate-y-1 hover:border-blue-100 hover:bg-white hover:shadow-lg hover:shadow-blue-500/5">
            <div className="flex items-start justify-between">
              <Icon icon={item.icon} className="text-3xl text-[#004790]" />
              <span className="font-display text-4xl font-light italic text-gray-200 transition-colors group-hover:text-[#d3a641]/40">
                {item.number}
              </span>
            </div>
            <h3 className="mt-5 text-lg font-bold text-gray-900">{item.title}</h3>
            <p className="mt-2 text-sm leading-relaxed text-gray-500">{item.body}</p>
          </div>
        ))}
      </div>
    </div>
  </section>
);

export default TheKnowledgeProblem;
